import { render, staticRenderFns } from "./IconFlashCard.vue?vue&type=template&id=004a458c"
import script from "./IconFlashCard.vue?vue&type=script&lang=js"
export * from "./IconFlashCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports